module.exports = __webpack_public_path__ + "static/media/brand-06.7127d39b.png";